import React, { useEffect } from 'react';
import { t } from '@lingui/macro';
import { FaHighlighter, FaSearchMinus } from 'react-icons/fa';

import { useAccessibilityContext } from '../Providers/AccessibilityProvider/AccessibilityContext';
import { AccessibilityOption } from './AccessibilityButton';

const HightlightLink = () => {
  const { setIsHightlightLink, isHightlightLink } = useAccessibilityContext();

  useEffect(() => {
    if (isHightlightLink) {
      addHightlight();
    } else {
      removeHightlight();
    }
  }, [isHightlightLink]);

  function toggleHightLight() {
    if (setIsHightlightLink) {
      setIsHightlightLink(!isHightlightLink);
    }
  }

  function addHightlight() {
    document.querySelector('body')?.classList.add('hightlight_link');
  }

  function removeHightlight() {
    document.querySelector('body')?.classList.remove('hightlight_link');
  }

  return (
    <AccessibilityOption
      name={'Resaltar enlaces'}
      icon={<FaHighlighter className="h-3 w-3 fill-white" />}
      onClick={() => toggleHightLight()}
    />
  );
};

export default HightlightLink;
